/**
 * Creator v2 — limits and the step map.
 *
 * Clue counts (Phase 8, decision D2): a puzzle needs at least 2 clues, 3 is the
 * recommended length, 10 is the most. The Rules allow 1–10
 * (`levels.size() >= 1 && <= 10`); tests/rules/rules-constants-sync.test.js keeps
 * MAX_CLUES tied to the Rules literal.
 */
export const MIN_CLUES = 2;
export const RECOMMENDED_CLUES = 3;
export const MAX_CLUES = 10;

// Text limits — the same values the old creator enforced, plus the Rules caps.
export const LIMITS = {
  name: 40,
  title: 100, // Rules: title.size() <= 100
  question: 500,
  answer: 100,
  hint: 200,
  clueTitle: 100,
  message: 500, // a clue's "A few words" celebration
  finalMessage: 2000,
  word: 64, // Rules: password.size() <= 256
  wordHint: 200,
};
export const MIN_WORD_LENGTH = 3;

// Celebration types — same values the player and the puzzle doc already use.
export const CELEBRATIONS = ["default", "message", "photo", "video", "song"];
export const PRO_CELEBRATIONS = ["photo", "video", "song"];

/**
 * Every screen of the flow, and which of the four progress segments it lights
 * (0 Start · 1 Clues · 2 Reveal · 3 Send). The progress indicator is identical on
 * every theme (decision D4).
 */
export const STEPS = {
  name: 0,
  vibe: 0,
  question: 1,
  answer: 1,
  celebration: 1,
  celebrationDetail: 1,
  reward: 1,
  hint: 1,
  clueName: 1,
  list: 1,
  reveal: 2,
  seal: 3,
  word: 3,
  ready: 3,
  share: 3,
};
